import { createSelector } from '@reduxjs/toolkit';
import { selectOffersHistory } from './selectOffersHistory';

export const selectOfferFromHistory = createSelector(
  selectOffersHistory,
  ({
    activeOfferId,
    data: {
      offers: { data },
    },
  }) => (activeOfferId ? data[activeOfferId] : null),
);
